import React from "react";
import { Grid } from "@material-ui/core";
import { Field } from "redux-form/immutable";

import { generateFormName } from "utils/app.util";
import { HELI_REPORT_FORM } from "features/planner/report/report.constants";
import HeliReportRow from "features/planner/report/helicopter/components/HeliReportRow";
import HeliReportColumn from "features/planner/report/helicopter/components/HeliReportColumn";
import HeliReportClearRow from "features/planner/report/helicopter/components/HeliReportClearRow";
import TextFieldColumnField from "features/planner/report/helicopter/components/TextFieldColumnField";

const ShoreBoundRow = ({ index }) => (
  <HeliReportRow>
    <Grid container item xs alignItems="center">
      <HeliReportColumn xs={true}>
        <Field
          component={TextFieldColumnField}
          name={generateFormName(
            HELI_REPORT_FORM.SHORE_BOUND,
            index,
            HELI_REPORT_FORM.OFFSHORE_ID,
          )}
        />
      </HeliReportColumn>
      <HeliReportColumn xs={4}>
        <Field
          component={TextFieldColumnField}
          name={generateFormName(
            HELI_REPORT_FORM.SHORE_BOUND,
            index,
            HELI_REPORT_FORM.DISPLAY_NAME,
          )}
        />
      </HeliReportColumn>
      <HeliReportColumn xs={true}>
        <Field
          component={TextFieldColumnField}
          name={generateFormName(
            HELI_REPORT_FORM.SHORE_BOUND,
            index,
            HELI_REPORT_FORM.DATE,
          )}
        />
      </HeliReportColumn>
      <HeliReportColumn xs={true}>
        <Field
          component={TextFieldColumnField}
          name={generateFormName(
            HELI_REPORT_FORM.SHORE_BOUND,
            index,
            HELI_REPORT_FORM.DEPARTURE,
          )}
        />
      </HeliReportColumn>
      <Grid item>
        <HeliReportClearRow index={index} type={HELI_REPORT_FORM.SHORE_BOUND} />
      </Grid>
    </Grid>
  </HeliReportRow>
);

export default ShoreBoundRow;
